"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertedMyPageMenuWidgetDataSchema = exports.MyPageMenuWidgetDataSchema = void 0;
var zod_1 = require("zod");
exports.MyPageMenuWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.object({ title: zod_1.z.string() }).nullable(),
    items: zod_1.z.array(zod_1.z.object({
        items: zod_1.z.array(zod_1.z.object({
            action: zod_1.z.object({
                app: zod_1.z.string(),
                web: zod_1.z.string(),
            }),
            isBullet: zod_1.z.boolean(),
            subtitle: zod_1.z.string().nullable(),
            title: zod_1.z.string(),
            serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
        })),
    })),
});
var ConvertedMyPageMenuItemWidgetDataSchema = zod_1.z.object({
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    isBullet: zod_1.z.boolean(),
    subtitle: zod_1.z.string().nullable(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
exports.ConvertedMyPageMenuWidgetDataSchema = zod_1.z.object({
    header: zod_1.z.string(),
    items: zod_1.z.array(ConvertedMyPageMenuItemWidgetDataSchema),
});
